import React, { CSSProperties } from "react";

export interface TabContentProps {
  label?: React.ReactNode;
  currentTabName?: string;
  name: string;
  visible?: boolean;
  disabled?: boolean;
}

const sytle: CSSProperties = {
  paddingBottom: "10px",
}

const TabContent: React.FC<TabContentProps> = ({
  label,
  name,
  currentTabName,
  children,
  visible = true,
}) => {
  let ocultar = name !== currentTabName;

  if (!ocultar && !visible) {
    ocultar = true;
  }

  return <div hidden={ocultar} style={sytle}>{children}</div>;
};

export { TabContent };
